export default {
  userSettings: (state) => state.userSettings,
  mutatedUserSettings: (state) => state.mutatedUserSettings
}
